/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const Pagination = core.serialization.object({
    currentPage: core.serialization.number(),
    pageCount: core.serialization.number(),
    totalCount: core.serialization.number(),
});
